module.exports = __webpack_public_path__ + "static/media/gn.8e74ea04.svg";